import { render, staticRenderFns } from "./buyer-profile-index.vue?vue&type=template&id=12436505"
import script from "./buyer-profile-index.vue?vue&type=script&lang=js"
export * from "./buyer-profile-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports